import React from "react";
import { Box, Typography, Container } from "@mui/material";

const ComingSoon: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            textAlign: "center",
            backgroundColor: "rgba(255, 255, 255, 0.95)",
            borderRadius: "20px",
            padding: { xs: 4, md: 6 },
            boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
          }}
        >
          {/* Logo */}
          <Box
            sx={{
              mb: 4,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              src={require("../../assets/logo.png")}
              alt="logo"
              style={{
                maxWidth: "200px",
                width: "100%",
                height: "auto",
              }}
            />
          </Box>

          {/* Main Heading */}
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: "2rem", md: "2.5rem" },
              fontWeight: 600,
              mb: 2,
              color: "#1e3c72",
            }}
          >
            Coming Soon
          </Typography>

          {/* Divider */}
          <Box
            sx={{
              width: "80px",
              height: "4px",
              backgroundColor: "#2a5298",
              margin: "0 auto 24px",
              borderRadius: "2px",
            }}
          />

          {/* Message */}
          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: "1rem", md: "1.125rem" },
              color: "#555",
              lineHeight: 1.8,
              mb: 3,
            }}
          >
            We're currently working on something exciting.
            <br />
            Our platform will be available shortly.
          </Typography>

          {/* Footer note */}
          <Typography
            variant="body2"
            sx={{
              color: "#888",
              fontSize: { xs: "0.875rem", md: "0.95rem" },
            }}
          >
            Thank you for your patience
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default ComingSoon;
